import {
  NMIAccountInfoModel,
  NMIMerchantAccountModel,
  NMIProcessorFieldsModel,
} from "../../../shared/models/NMIFormModels";
import {
  CreatableSelect,
  CustomButton,
  CustomLabel,
  FlexContainer,
  Input,
  IOption,
  RedButton,
  SingleSelect,
  StyledTooltip,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  CountryDropdown,
  CountryPhoneDropdown,
} from "../../../shared/components";
import MerchantAccountStore from "../MerchantAccountStore";
import { NavigateFunction } from "react-router-dom";
import {
  CountryStore,
  ItemsStore,
  RolesAndPermissionStore,
} from "../../../shared/store";
import { observer } from "mobx-react";
import {
  NMIAccountHolderType,
  NMIAccountType,
  NMIProcessorTypes,
} from "../../../shared/enums";
import { MainOuterCard } from "../../../shared/styles";
import { MerchantBlocks, MerchantWrapper } from "./Merchant.styles";
import MindMePaymentsLogo from "../../../../../../images/logos/mindme-payments-logo.png";
import {
  CountryWithStateModel,
  SelectedItemModel,
} from "../../../shared/models";
import GenericDropdown, {
  GenericItem,
} from "../../../shared/components/GenericDropdown";
import { DashboardTopBar, ItemContentArea } from "../../../shared/components";
import TSYSLogo from "../../../../../../images/logos/tsys-logo.svg";
import ElavonLogo from "../../../../../../images/logos/elavon-logo.svg";
import GlobalPaymentsLogo from "../../../../../../images/logos/global-payments-logo.svg";
import fiservLogo from "../../../../../../images/logos/fiserv-logo.svg";

type IProps = {
  merchantAccountStore: MerchantAccountStore;
  navigate: NavigateFunction;
  rolesAndPermissionStore: RolesAndPermissionStore;
  itemStore: ItemsStore;
};

const accountHolderTypeOptions = Object.keys(NMIAccountHolderType).map(
  (type) => ({
    label: type,
    value: NMIAccountHolderType[type],
  }),
);

const accountTypeOptions = Object.keys(NMIAccountType).map((type) => ({
  label: type,
  value: NMIAccountType[type],
}));

const processorOptions: GenericItem[] = [
  {
    label: "TSYS",
    value: "Tsys",
    imageUrl: TSYSLogo,
    dropdownItemClass: "tsys-logo-class",
  },
  {
    label: "First Data Nashville",
    value: "FirstDataNashville",
    imageUrl: fiservLogo,
    dropdownItemClass: "fiserv-logo-class",
  },
  {
    label: "First Data Rapid Connect Nashville North - EMV (Fiserv)",
    value: "FirstDataRapidConnectNashvilleNorthEMV",
    imageUrl: fiservLogo,
    dropdownItemClass: "fiserv-logo-class",
  },
  {
    label: "First Data Nashville North",
    value: "FirstDataNashvilleNorth",
    imageUrl: fiservLogo,
    dropdownItemClass: "fiserv-logo-class",
  },
  {
    label: "First Data Rapid Connect Cardnet North - EMV (Fiserv)",
    value: "FirstDataRapidConnectCardnetNorthEMV",
    imageUrl: fiservLogo,
    dropdownItemClass: "fiserv-logo-class",
  },
  // {
  //   label: "Elavon - EMV",
  //   value: "ElavonEMV",
  //   imageUrl: ElavonLogo,
  //   dropdownItemClass: "elavon-logo-class",
  // },
  {
    label: "Global Payments East EMV",
    value: "GlobalPaymentsEastEMV",
    imageUrl: GlobalPaymentsLogo,
    dropdownItemClass: "globalPayment-logo-class",
  },

  //  {
  //     label: "First Data Canada (Fiserv)",
  //   value: "FirstDataCanada",
  //   imageUrl: fiservLogo,
  //   dropdownItemClass: "fiserv-logo-class",
  // },
  // {
  //   label: "First Data Omaha (Fiserv)",
  //   value: "FirstDataOmaha",
  //   imageUrl: fiservLogo,
  //   dropdownItemClass: "fiserv-logo-class",
  // },
  // {
  //   label: "First Data Rapid Connect Omaha - EMV (Fiserv)",
  //   value: "FirstDataRapidConnectOmahaEMV",
  //   imageUrl: fiservLogo,
  //   dropdownItemClass: "fiserv-logo-class",
  // }
];

const paymentTypeOptions: IOption[] = [
  { label: "Visa", value: "visa" },
  { label: "Mastercard", value: "mastercard" },
  { label: "American Express", value: "amex" },
  { label: "Discover", value: "discover" },
  { label: "Diners Club", value: "diners" },
  { label: "JCB", value: "jcb" },
  { label: "Maestro", value: "maestro" },
];

const accountClassificationOptions: IOption[] = [
  { label: "E‑Commerce", value: "ecommerce" },
  { label: "Retail", value: "retail" },
  { label: "MOTO", value: "moto" },
  { label: "Restaurant", value: "restaurant" },
];

const currencyOptions: IOption[] = [{ label: "USD", value: "USD" }];

const ProcessorFieldWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const InfoHintIcon = styled.span`
  position: absolute;
  /* anchor to the input's vertical center (input height ~40px) so the icon
     stays centered on the field even when an error message renders below it */
  top: 20px;
  right: 10px;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #99a3c4;
  color: #556bb8;
  font-size: 11px;
  font-style: italic;
  font-weight: 600;
  line-height: 16px;
  text-align: center;
  cursor: pointer;
  user-select: none;
  background-color: #fff;
  z-index: 1;
`;

/* Inline variant of the hint icon used next to checkboxes (which have no
   absolutely-positioned input container to anchor to). */
const InlineHintIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 6px;
  border-radius: 50%;
  border: 1px solid #99a3c4;
  color: #556bb8;
  font-size: 11px;
  font-style: italic;
  font-weight: 600;
  line-height: 16px;
  text-align: center;
  cursor: pointer;
  user-select: none;
  background-color: #fff;
  flex: 0 0 auto;
`;

const CheckboxHintWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const DropdownHintWrapper = styled.div`
  position: relative;
  display: inline-block;
  flex: 1;
`;

const DropdownHintIcon = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #99a3c4;
  color: #556bb8;
  font-size: 11px;
  font-style: italic;
  font-weight: 600;
  line-height: 16px;
  text-align: center;
  cursor: pointer;
  user-select: none;
  background-color: #fff;
  z-index: 2;
`;

const NMIMerchantAccountSignUp: React.FC<IProps> = ({
  merchantAccountStore,
  rolesAndPermissionStore,
  navigate,
  itemStore,
}) => {
  const { nmiApplicationData } = merchantAccountStore;
  const [isSaveInProgress, setIsSaveInProgress] = useState(false);

  useEffect(() => {
    merchantAccountStore.initNewApplicationData(itemStore.countryStore);
  }, [itemStore.countryStore.countryDataLoaded]);

  useEffect(() => {
    itemStore?.setBreadCrumbData(
      new SelectedItemModel({
        route: "/app/merchant-accounts",
        title: "Connect Merchant Application",
      }),
    );

    return () => {
      itemStore?.setBreadCrumbData();
    };
  }, []);

  const stateOptionsForContact = (
    nmiApplicationData.countryDetails?.states || []
  )
    .map((state) => {
      return {
        label: state.name,
        value: state.id,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));

  const stateOptionsForNMIProcessor = (
    nmiApplicationData.processorFields.country?.states || []
  )
    .map((state) => {
      return {
        label: state.name,
        value: state.abbreviationName,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));

  const updateField = (key: keyof NMIMerchantAccountModel, value: any) => {
    merchantAccountStore.updateNmiApplicationData(
      new NMIMerchantAccountModel({
        ...nmiApplicationData,
        [key]: value,
        processorFields:
          key === "processor" && value !== nmiApplicationData.processor
            ? new NMIProcessorFieldsModel({ processor: value })
            : key === "processorFields"
              ? value
              : nmiApplicationData.processorFields,
      }),
    );
  };

  const updateAccountInfo = (key: keyof NMIAccountInfoModel, value: string) => {
    const updatedAccountInfo = new NMIAccountInfoModel({
      ...nmiApplicationData.accountInfo,
      [key]: value,
    });
    updateField("accountInfo", updatedAccountInfo);
  };

  const handleSubmit = async () => {
    if (nmiApplicationData.validate()) {
      setIsSaveInProgress(true);
      try {
        const id = await merchantAccountStore.submitNMIApplication();
        if (id) {
          merchantAccountStore.resetNMIApplicationData(itemStore.countryStore);
          navigate(`/app/merchant-accounts`);
        }
      } catch (error) {
        console.error("Error submitting NMI application:", error);
      } finally {
        setIsSaveInProgress(false);
      }
    } else {
      merchantAccountStore.updateNmiApplicationData(nmiApplicationData);
      setIsSaveInProgress(false);
    }
  };

  const handleCancel = () => {
    merchantAccountStore.updateNmiApplicationData(
      new NMIMerchantAccountModel({
        countryDetails: itemStore.countryStore.getUSCountry(),
        phoneCountryDetails: itemStore.countryStore.getUSCountry(),
        processorFields: new NMIProcessorFieldsModel({
          country: itemStore.countryStore.getUSCountry(),
        }),
      }),
    );
    navigate("/app/merchant-accounts");
  };

  const updateProcessorFields = (
    key: keyof NMIProcessorFieldsModel,
    value: string | boolean | CountryWithStateModel,
  ) => {
    const updatedNMIFields = new NMIProcessorFieldsModel({
      ...nmiApplicationData.processorFields,
      [key]: value,
    });
    updateField("processorFields", updatedNMIFields);
  };

  const textInput = (
    value: string,
    key: keyof NMIMerchantAccountModel | keyof NMIAccountInfoModel,
    placeholder: string,
    type: string = "text",
    isAccountInput: boolean = false,
    hint?: string,
  ) => {
    const model = isAccountInput
      ? nmiApplicationData.accountInfo
      : nmiApplicationData;
    const updater = isAccountInput ? updateAccountInfo : updateField;

    const input = (
      <Input
        type={type as any}
        value={value}
        error={model.hasError(key as any)}
        errorMessage={model.getErrorMessage(key as any) || ""}
        className="styled-input merchant-inputs"
        onChange={(e) => updater(key as any, e.target.value)}
        placeholder={placeholder}
      />
    );

    if (!hint) {
      return input;
    }

    return (
      <ProcessorFieldWrapper>
        {input}
        <StyledTooltip tooltipText={hint} placement="top">
          <InfoHintIcon>i</InfoHintIcon>
        </StyledTooltip>
      </ProcessorFieldWrapper>
    );
  };

  const textInputForProcessorFields = (
    value: string,
    key: keyof NMIProcessorFieldsModel,
    placeholder: string,
    type: string = "text",
    hint?: string,
  ) => {
    const { processorFields } = nmiApplicationData;
    const input = (
      <Input
        type={type as any}
        value={value}
        error={processorFields.hasError(key)}
        errorMessage={processorFields.getErrorMessage(key) || ""}
        className="styled-input merchant-inputs"
        onChange={(e) => updateProcessorFields(key, e.target.value)}
        placeholder={placeholder}
      />
    );

    if (!hint) {
      return input;
    }

    return (
      <ProcessorFieldWrapper>
        {input}
        <StyledTooltip tooltipText={hint} placement="top">
          <InfoHintIcon>i</InfoHintIcon>
        </StyledTooltip>
      </ProcessorFieldWrapper>
    );
  };

  const checkBoxInput = (
    key: keyof NMIProcessorFieldsModel,
    value: boolean,
    label: string,
    disabled: boolean,
    hint?: string,
  ) => {
    const input = (
      <Input
        type="checkbox"
        value={value}
        onChange={(e) =>
          updateProcessorFields(
            key as keyof NMIProcessorFieldsModel,
            e.target.checked,
          )
        }
        label={label}
        disabled={disabled || false}
      />
    );

    if (!hint) {
      return input;
    }

    return (
      <CheckboxHintWrapper>
        {input}
        <StyledTooltip tooltipText={hint} placement="top">
          <InlineHintIcon>i</InlineHintIcon>
        </StyledTooltip>
      </CheckboxHintWrapper>
    );
  };

  const singleSelect = (
    label: string,
    selectedKey: string,
    key: keyof NMIAccountInfoModel | keyof NMIMerchantAccountModel,
    options: IOption[],
    isAccountInfo: boolean = true,
  ) => {
    return (
      <SingleSelect
        selectedKey={selectedKey}
        hasError={
          isAccountInfo
            ? nmiApplicationData.accountInfo.hasError(
                key as keyof NMIAccountInfoModel,
              )
            : nmiApplicationData.hasError(key as keyof NMIMerchantAccountModel)
        }
        searchable={key === "country" || key === "stateId" ? true : false}
        searchPlaceholder="Search..."
        nameKeys={["label"]}
        valueKeys={["value"]}
        options={[options]}
        placeholder={label}
        errorMessage={
          isAccountInfo
            ? nmiApplicationData.accountInfo.getErrorMessage(
                key as keyof NMIAccountInfoModel,
              )
            : nmiApplicationData.getErrorMessage(
                key as keyof NMIMerchantAccountModel,
              )
        }
        onChange={(option: any) =>
          isAccountInfo
            ? updateAccountInfo(key as keyof NMIAccountInfoModel, option.value)
            : updateField(key as keyof NMIMerchantAccountModel, option.value)
        }
        className="dpdn-no-separator btn-caption-dpdn"
        emptySelection={label}
      />
    );
  };

  const singleSelectForProcessorFields = (
    label: string,
    selectedKey: string,
    key: keyof NMIProcessorFieldsModel,
    options: IOption[],
  ) => {
    return (
      <SingleSelect
        selectedKey={selectedKey}
        searchable={key === "state" ? true : false}
        searchPlaceholder="Search..."
        hasError={nmiApplicationData.processorFields.hasError(key)}
        nameKeys={["label"]}
        valueKeys={["value"]}
        options={[options]}
        placeholder={label}
        errorMessage={nmiApplicationData.processorFields.getErrorMessage(key)}
        onChange={(option: any) => updateProcessorFields(key, option.value)}
        className="dpdn-no-separator btn-caption-dpdn"
        emptySelection={label}
      />
    );
  };

  const handleSelect = (
    id: string | null,
    fieldName: keyof NMIMerchantAccountModel,
  ) => {
    if (id) {
      const country = itemStore.countryStore.countriesWithState.find(
        (country) => country.id === id,
      );
      if (country) {
        updateField(fieldName, country);
      }
    }
  };

  const handleSelectForProcessorField = (
    id: string | null,
    fieldName: keyof NMIProcessorFieldsModel,
  ) => {
    if (id) {
      const country = itemStore.countryStore.countriesWithState.find(
        (country) => country.id === id,
      );
      if (country) {
        updateProcessorFields(fieldName, country);
      }
    }
  };

  const renderHeader = () => {
    return (
      <FlexContainer alignItems="center" justifyContent="space-between">
        <img
          src={MindMePaymentsLogo}
          className="mindme-payment-icon"
          alt="MindMe Payments Logo"
        />
        <CustomLabel
          fontSize="30px"
          fontWeight="600"
          color="#000"
          textAlign="center"
        >
          Connect Merchant
          <br /> Application
        </CustomLabel>
        <CustomLabel
          fontSize="12px"
          textAlign="right"
          className="desc-merchant-form"
        >
          Complete a short form below to apply for a processing account and
          start taking payments online.
        </CustomLabel>
      </FlexContainer>
    );
  };

  const renderAccountInfoFields = () => {
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">
          Account Details
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInput(
            nmiApplicationData.accountInfo.checkAccount,
            "checkAccount",
            "Check Account",
            "text",
            true,
            "Bank account (DDA) number where your settled funds will be deposited.",
          )}
          {textInput(
            nmiApplicationData.accountInfo.checkAba,
            "checkAba",
            "Check ABA",
            "text",
            true,
            "9 digit bank routing / ABA number for the settlement (deposit) account.",
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {singleSelect(
            "Select Account Holder Type",
            nmiApplicationData.accountInfo.accountHolderType,
            "accountHolderType",
            accountHolderTypeOptions,
          )}

          {singleSelect(
            "Select Account Type",
            nmiApplicationData.accountInfo.accountType,
            "accountType",
            accountTypeOptions,
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  const renderProcessorSelection = () => {
    const errorMessage = nmiApplicationData.getErrorMessage("processor");
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">Processor</CustomLabel>
        <FlexContainer
          alignItems="center"
          spacing={20}
          className="country-origin-dpdn"
        >
          {/* {singleSelect(
            "Select Processor",
            nmiApplicationData.processor,
            "processor",
            processorOptions,
            false
          )} */}
          <GenericDropdown
            selectedItem={processorOptions.find(
              (item) => item.value === nmiApplicationData.processor,
            )}
            items={processorOptions}
            onItemChange={(value) => updateField("processor", value)}
            error={errorMessage?.length > 0}
            errorMessage={errorMessage}
            placeholder="Processor"
            className="country-dropdown nmi-country-dropdown processor-dropdown"
          />
          {singleSelect(
            "Select Account Classification",
            nmiApplicationData.processorAccountClassification,
            "processorAccountClassification",
            accountClassificationOptions,
            false,
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {textInput(
            nmiApplicationData.maxMonthlyVolume,
            "maxMonthlyVolume",
            "Max Monthly Volume",
            "text",
            false,
            "Highest total card volume you expect to process in a single month, in USD.",
          )}
          {/* MCC is always collected here in the Processor section for every
              processor. When a processor also requires MCC as a processor
              field, the shared value is mapped into that field in the API
              model (see NMIProcessorFieldsModel.createAPIModel). */}
          {textInput(
            nmiApplicationData.mcc,
            "mcc",
            "Merchant Category Code (4 digits)",
            "text",
            false,
            "4 digit MCC/SIC Code",
          )}
          {/* {textInput(
            nmiApplicationData.duplicateTime,
            "duplicateTime",
            "Duplicate Time in seconds eg. 1200",
            "text"
          )} */}
        </FlexContainer>
        {/* <FlexContainer alignItems="center" spacing={20}>
          <CreatableSelect
            isMulti={true}
            options={paymentTypeOptions}
            selectedOptions={
              nmiApplicationData.paymentTypes.map((type) => ({
                label: type,
                value: type,
              })) || []
            }
            allowCreateOption={false}
            onChange={(newMethods) =>
              updateField(
                "paymentTypes",
                newMethods.map((m) => m.value)
              )
            }
            error={nmiApplicationData.hasError("paymentTypes")}
            errorMessage={nmiApplicationData.getErrorMessage("paymentTypes")}
            className="payment-method-select nmi-payment-method-select"
            classPrefix="payment-method"
            placeholder="Select Payment Methods"
          />
        </FlexContainer> */}
        {/* <FlexContainer alignItems="center" spacing={20}>
          <CreatableSelect
            isMulti={true}
            options={currencyOptions}
            selectedOptions={
              nmiApplicationData.currencies.map((currency) => ({
                label: currency,
                value: currency,
              })) || []
            }
            error={nmiApplicationData.hasError("currencies")}
            errorMessage={nmiApplicationData.getErrorMessage("currencies")}
            allowCreateOption={false}
            onChange={(newCurrencies) =>
              updateField(
                "currencies",
                newCurrencies.map((m) => m.value)
              )
            }
            className="payment-method-select nmi-payment-method-select"
            placeholder="Select Currencies"
            classPrefix="Currency"
          />
        </FlexContainer> */}
      </MerchantBlocks>
    );
  };

  const renderTSYSFields = () => {
    const tsysData = nmiApplicationData.processorFields;

    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">
          TSYS Processor Details
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            tsysData.acquirerBIN,
            "acquirerBIN",
            "Acquirer BIN",
            "text",
            "6 digit BIN/Acquirer ID",
          )}
          {textInputForProcessorFields(
            tsysData.merchantNumber,
            "merchantNumber",
            "Merchant Number",
            "text",
            "12 digit Merchant number (Vital Merchant ID)",
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            tsysData.storeNumber,
            "storeNumber",
            "Store Number",
            "text",
            "4 digit Store Number",
          )}
          {textInputForProcessorFields(
            tsysData.terminalNumber,
            "terminalNumber",
            "Terminal Number",
            "text",
            "4 digit Terminal#/Terminal Number",
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            tsysData.locationNumber,
            "locationNumber",
            "Location Number",
            "text",
            "5 digit Location Number. If the VAR sheet shows 6 digits, drop the leading zero.",
          )}
          {/* {textInputForProcessorFields(
            tsysData.timeZoneDifferential,
            "timeZoneDifferential",
            "Time Zone Diff",
            "text"
          )}   */}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            tsysData.vitalNumber,
            "vitalNumber",
            "Vital Number",
            "text",
            "8 digit V-Number/Terminal ID.  Replace a leading 'V' with '7' (e.g. V1234567 becomes 71234567).",
          )}
          {textInputForProcessorFields(
            tsysData.agentBank,
            "agentBank",
            "Agent Bank",
            "text",
            "6 digit Agent/Agency Number",
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            tsysData.agentChain,
            "agentChain",
            "Agent Chain",
            "text",
            "6 digit Chain/Chain Number",
          )}
          {textInputForProcessorFields(
            tsysData.city,
            "city",
            "City",
            "text",
            "City",
          )}
        </FlexContainer>
        <FlexContainer
          alignItems="center"
          spacing={20}
          className="country-origin-dpdn"
        >
          <CountryDropdown
            selectedCountry={tsysData.country}
            error={tsysData.hasError("country")}
            errorMessage={"Please select country"}
            className="country-dropdown nmi-country-dropdown"
            onCountryChange={(id: string) =>
              handleSelectForProcessorField(id, "country")
            }
            availableCountries={itemStore.countryStore.sortCountriesByName()}
          />
          {singleSelectForProcessorFields(
            "Select State",
            nmiApplicationData.processorFields.state,
            "state",
            stateOptionsForNMIProcessor,
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            tsysData.zip,
            "zip",
            "ZIP Code",
            "text",
            "Zip or Postal Code",
          )}
          {/* {textInputForProcessorFields(
            tsysData.timeZoneDifferential,
            "timeZoneDifferential",
            "Time Zone Diff",
            "text"
          )} */}
        </FlexContainer>
        {/* <FlexContainer alignItems="center" spacing={20}>
          {singleSelectForProcessorFields(
            "Select Merchant Category",
            tsysData.merchantCategory,
            "merchantCategory",
            merchantAccountStore.getMCCCodeDropdownOptions()
          )}

          {textInputForProcessorFields(
            tsysData.merchantCategory,
            "merchantCategory",
            "Merchant Category Code (4 digits)",
            "text"
          )}
        </FlexContainer> */}
        <FlexContainer alignItems="center" spacing={20}>
          {checkBoxInput(
            "canAcceptCanadianMasterCardDebitCards",
            tsysData.canAcceptCanadianMasterCardDebitCards,
            "Merchant can accept Canadian MasterCard Debit Cards",
            false,
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  const renderElavonFields = () => {
    const label =
      nmiApplicationData.processor === "ElavonEMV"
        ? "Elavon - EMV"
        : "Elavon - Via Conex";
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">
          {label} Processor Fields
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.visaMerchantId,
            "visaMerchantId",
            "Merchant ID (MID)",
            "text",
            "6 to 16 digit Merchant ID (MID)",
          )}
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.terminalId,
            "terminalId",
            "Terminal ID (TID)",
            "text",
            "3 to 16 digit Terminal ID (TID)",
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  // Elavon - EMV uses its own field set (Bank Number, Terminal ID, Merchant
  // ID) per the ELAVON_EMV_CONFIG serviceConfig.
  const renderElavonEMVFields = () => {
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">
          Elavon - EMV Processor Fields
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.bankNumber,
            "bankNumber",
            "Bank Number",
            "text",
            "6 digit Bank Number",
          )}
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.terminalId,
            "terminalId",
            "Terminal ID",
            "text",
            "Up to 16 digit Terminal ID",
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.visaMerchantId,
            "visaMerchantId",
            "Merchant ID",
            "text",
            "Up to 16 digit Merchant ID",
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  const renderFDMSFields = () => {
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">
          First Data Nashville Processor Fields
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.merchantNumber,
            "merchantNumber",
            "Merchant ID",
            "text",
            "7 digit MID",
          )}
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.terminalId,
            "terminalId",
            "Terminal ID",
            "text",
            "7 digit Terminal ID",
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {checkBoxInput(
            "ignoreAmexCVVResult",
            nmiApplicationData.processorFields.ignoreAmexCVVResult,
            "Ignore Amex CVV Results",
            false,
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {checkBoxInput(
            "disablePurchaseReturnAuthorization",
            nmiApplicationData.processorFields
              .disablePurchaseReturnAuthorization,
            "Disable Purchase Return Authorization functionality for refunds and credits",
            false,
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  // First Data Nashville North uses its own field set per the
  // FIRST_DATA_NASHVILLE_NORTH_CONFIG serviceConfig (distinct from the shared
  // Rapid Connect North / Cardnet North fields).
  const renderFirstDataNashvilleNorthFields = () => {
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">
          First Data Nashville North Processor Fields
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.merchantNumber,
            "merchantNumber",
            "Merchant ID",
            "text",
            "12 digit Merchant ID",
          )}
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.terminalId,
            "terminalId",
            "Terminal ID",
            "text",
            "1-8 character Terminal ID (letters or numbers)",
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {checkBoxInput(
            "disablePurchaseReturnAuthorization",
            nmiApplicationData.processorFields
              .disablePurchaseReturnAuthorization,
            "Disable Purchase Return Authorization functionality for refunds and credits",
            false,
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  const renderFirstDataNashvilleNorthV2Fields = () => {
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">
          First Data Nashville North V2 Processor Fields
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.merchantNumber,
            "merchantNumber",
            "Merchant ID",
            "text",
            "12 digit Merchant ID",
          )}
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.terminalId,
            "terminalId",
            "Terminal ID",
            "text",
            "1-8 character Terminal ID (letters or numbers)",
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {checkBoxInput(
            "aggregatorMID",
            nmiApplicationData.processorFields.aggregatorMID,
            "Aggregator MID",
            false,
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {checkBoxInput(
            "disablePurchaseReturnAuthorization",
            nmiApplicationData.processorFields
              .disablePurchaseReturnAuthorization,
            "Disable Purchase Return Authorization functionality for refunds and credits",
            false,
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  const renderFirstDataRapidConnect = () => {
    // Nashville North, Nashville North V2 and Cardnet North share the same
    // fields, hints and validation; only the section title differs.
    const processor =
      nmiApplicationData.processor === "FirstDataRapidConnectNashvilleNorthEMV"
        ? "First Data Rapid Connect Nashville North - EMV"
        : nmiApplicationData.processor === "FirstDataNashvilleNorth"
          ? "First Data Nashville North"
          : nmiApplicationData.processor === "FirstDataNashvilleNorthV2"
            ? "First Data Nashville North V2"
            : "First Data Rapid Connect Cardnet North - EMV";
    const merchantNumberHint = "7 digit Frontend MID";
    const terminalIdHint = "7 digit Bank TID";
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">
          {processor} Processor Fields
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.merchantNumber,
            "merchantNumber",
            "Merchant Number",
            "text",
            merchantNumberHint,
          )}
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.terminalId,
            "terminalId",
            "Terminal ID",
            "text",
            terminalIdHint,
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.visaMerchantId,
            "visaMerchantId",
            "Settlement Merchant ID",
            "text",
            "12 digit North Settlement MID",
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  const renderFirstDataCanada = () => {
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">
          First Data Canada Processor Details
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.visaMerchantId,
            "visaMerchantId",
            "Visa Merchant ID",
            "text",
          )}
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.mastercardMerchantId,
            "mastercardMerchantId",
            "Mastercard Merchant ID",
            "text",
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.terminalId,
            "terminalId",
            "Terminal ID",
            "text",
          )}
          {/* {textInputForProcessorFields(
            nmiApplicationData.processorFields.merchantCategory,
            "merchantCategory",
            "Merchant Category Code (4 digits)",
            "text"
          )} */}
          {/* {singleSelectForProcessorFields(
            "Select Merchant Category",
            nmiApplicationData.processorFields.merchantCategory,
            "merchantCategory",
            merchantAccountStore.getMCCCodeDropdownOptions()
          )} */}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {checkBoxInput(
            "disablePurchaseReturnAuthorization",
            nmiApplicationData.processorFields
              .disablePurchaseReturnAuthorization,
            "Disable Purchase Return Authorization functionality for refunds and credits",
            false,
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  const renderFirstDataOmaha = () => {
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">
          First Data Omaha Processor Fields
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.merchantNumber,
            "merchantNumber",
            "Merchant Number",
            "text",
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  const renderFDRapidConnectOmahaOrNashville = () => {
    const processor =
      nmiApplicationData.processor === "FirstDataRapidConnectOmahaEMV"
        ? "First Data Rapid Connect Omaha"
        : "First Data Rapid Connect Nashville";
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">
          {processor} Processor Fields
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.merchantNumber,
            "merchantNumber",
            "Merchant Number",
            "text",
          )}
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.terminalId,
            "terminalId",
            "Terminal ID",
            "text",
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  const renderGlobalCollectFields = () => {
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">
          Global Collect Processor Fields
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.accountId,
            "accountId",
            "Account ID",
            "text",
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  const renderGlobalPaymentsEastFields = () => {
    const surchargingHelp =
      "Warning:  Certain rules and regulations may apply when using Convenience Fees/Surcharging based upon various factors. Merchants should be in contact with their merchant account representative to confirm eligibility and compliance.";
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">
          Global Payments East - EMV Processor Fields
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.visaMerchantId,
            "visaMerchantId",
            "Merchant ID",
            "text",
            "MID",
          )}
          {textInputForProcessorFields(
            nmiApplicationData.processorFields.bankNumber,
            "bankNumber",
            "Bank ID",
            "text",
            "6 digit Bank ID",
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {checkBoxInput(
            "merchantEnrolledForSurcharging",
            nmiApplicationData.processorFields.merchantEnrolledForSurcharging,
            "Merchant is enrolled for surcharging",
            false,
            surchargingHelp,
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  const renderProcessorFields = () => {
    const processor =
      nmiApplicationData.processor as keyof typeof NMIProcessorTypes;
    switch (processor) {
      case "Tsys":
        return renderTSYSFields();
      case "ElavonEMV":
        return renderElavonEMVFields();
      case "ElavonViaConex":
        return renderElavonFields();
      case "FirstDataNashville":
        return renderFDMSFields();
      case "FirstDataRapidConnectNashvilleNorthEMV":
        return renderFirstDataRapidConnect();
      case "FirstDataNashvilleNorth":
        return renderFirstDataNashvilleNorthFields();
      case "FirstDataNashvilleNorthV2":
        return renderFirstDataNashvilleNorthV2Fields();
      case "GlobalPaymentsEastEMV":
        return renderGlobalPaymentsEastFields();
      case "GlobalCollect":
        return renderGlobalCollectFields();
      case "FirstDataCanada":
        return renderFirstDataCanada();
      case "FirstDataOmaha":
        return renderFirstDataOmaha();
      case "FirstDataRapidConnectNashvilleEMV":
        return renderFDRapidConnectOmahaOrNashville();
      case "FirstDataRapidConnectOmahaEMV":
        return renderFDRapidConnectOmahaOrNashville();
      case "FirstDataRapidConnectCardnetNorthEMV":
        return renderFirstDataRapidConnect();
    }
  };

  const renderAddressFields = () => {
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-subheader">Address</CustomLabel>
        <FlexContainer
          alignItems="center"
          spacing={20}
          className="country-origin-dpdn"
        >
          {textInput(
            nmiApplicationData.address1,
            "address1",
            "Address Line 1",
            "text",
          )}
          {textInput(
            nmiApplicationData.address2,
            "address2",
            "Address Line 2",
            "text",
          )}{" "}
        </FlexContainer>
        <FlexContainer
          alignItems="center"
          spacing={20}
          className="country-origin-dpdn"
        >
          {textInput(nmiApplicationData.city, "city", "City", "text")}
          {textInput(nmiApplicationData.zipCode, "zipCode", "Zip Code", "text")}
        </FlexContainer>
        <FlexContainer
          alignItems="center"
          spacing={20}
          className="country-origin-dpdn"
        >
          <CountryDropdown
            selectedCountry={nmiApplicationData.countryDetails}
            error={nmiApplicationData.hasError("countryDetails")}
            errorMessage={"Please select country"}
            className="country-dropdown nmi-country-dropdown"
            onCountryChange={(id: string) => handleSelect(id, "countryDetails")}
            availableCountries={itemStore.countryStore.sortCountriesByName()}
          />
          {singleSelect(
            "Select State",
            nmiApplicationData.stateId,
            "stateId",
            stateOptionsForContact,
            false,
          )}
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  const renderContactFields = () => {
    return (
      <MerchantBlocks className="rows-margin-bottom">
        <CustomLabel className="merchant-header">DETAILS</CustomLabel>
        <CustomLabel className="merchant-subheader">
          Contact Details
        </CustomLabel>
        <FlexContainer alignItems="center" spacing={20}>
          {textInput(
            nmiApplicationData.firstName,
            "firstName",
            "First Name",
            "text",
          )}
          {textInput(
            nmiApplicationData.lastName,
            "lastName",
            "Last Name",
            "text",
          )}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {" "}
          {textInput(
            nmiApplicationData.username,
            "username",
            "User name",
            "text",
          )}
          {textInput(nmiApplicationData.email, "email", "Email", "text")}
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={20}>
          {textInput(
            nmiApplicationData.company,
            "company",
            "Company Name / Merchant Account Name",
            "text",
          )}
          <CountryPhoneDropdown
            selectedCountry={nmiApplicationData.phoneCountryDetails}
            error={
              nmiApplicationData.hasError("phone") ||
              nmiApplicationData.hasError("phoneCountryDetails")
            }
            errorMessage={
              "please enter 10 digit phone number and select country"
            }
            onCountryChange={(id: string) =>
              handleSelect(id, "phoneCountryDetails")
            }
            phoneNumber={nmiApplicationData.phone || ""}
            onPhoneNumberChange={(number: string) =>
              updateField("phone", number)
            }
            availableCountries={itemStore.countryStore.countriesWithState}
          />
        </FlexContainer>
      </MerchantBlocks>
    );
  };

  return (
    <MerchantWrapper>
      <MainOuterCard>
        {renderHeader()}
        {renderContactFields()}
        {renderAddressFields()}
        {renderAccountInfoFields()}
        {renderProcessorSelection()}
        {renderProcessorFields()}
        <FlexContainer
          alignItems="center"
          justifyContent="center"
          spacing={20}
          padding="80px 0px 0px"
        >
          <RedButton
            bgColor="#fff"
            borderColor="#556bb8"
            color="#556bb8"
            height="40px"
            onClick={handleCancel}
          >
            Cancel
          </RedButton>
          <CustomButton
            bgColor="#556bb8"
            borderColor="#556bb8"
            color="#fff"
            height="40px"
            onClick={handleSubmit}
            disabled={isSaveInProgress}
          >
            Connect
          </CustomButton>
        </FlexContainer>
      </MainOuterCard>
    </MerchantWrapper>
  );
};

export default withRouter(observer(NMIMerchantAccountSignUp));
